/**
 * Bekommt ein neu angelegter Termin ein TO-DO mit — und welches?
 *
 * Seit dem 18.09.2026 steht „Neuer Termin" in der Aktionsleiste jedes
 * Arbeitsstrangs (PO-Zettel). Wird er aus einem To-do heraus angelegt, soll er
 * auch dort landen und nicht nur am Vorgang: sonst stünde er im Verlauf des
 * falschen Strangs — genau das Umhängen, das man sich mit dem Knopf sparen
 * wollte.
 *
 * DIE EINE FALLE: Der Create-Dialog lässt den Vorgang ÄNDERN. Wer dort einen
 * anderen Vorgang wählt, darf das To-do des Ausgangs-Vorgangs nicht mitnehmen
 * — das Backend lehnt die Kombination mit 400 ab („To-do und Vorgang des
 * Termins passen nicht zusammen"), und der Nutzer sähe statt seines Termins
 * die Meldung „Verknüpfung fehlgeschlagen". Deshalb wird die Bindung still
 * fallen gelassen, sobald der gewählte Vorgang ein anderer ist.
 */
export function todoFuerNeuenTermin(a: {
    /** Das To-do, aus dem heraus angelegt wurde; null = aus dem Vorgang. */
    linkTodoId: number | null;
    /** Der Vorgang, aus dem heraus angelegt wurde. */
    linkVorgangId: number | null;
    /** Der Vorgang, der im Dialog wirklich gewählt ist. */
    gewaehlterVorgangId: number | null;
}): number | null {
    if (a.linkTodoId == null) return null;
    if (a.linkVorgangId == null || a.gewaehlterVorgangId == null) return null;
    return a.gewaehlterVorgangId === a.linkVorgangId ? a.linkTodoId : null;
}
